import { ApiService } from './api';

// "__any__" matches every registration made through an invite link (see RegistrationFilters on the backend).
export const ANY_INVITE = '__any__';

const openExport = (url) => {
  const frame = document.createElement('iframe');
  frame.style.display = 'none';
  frame.src = url;
  document.body.appendChild(frame);
  setTimeout(() => frame.remove(), 5 * 60 * 1000);
};

/** Starts an Excel download of registrations through one invite link, or all links when linkId is omitted. */
export async function downloadInviteRegistrations(eventId, linkId) {
  const { url } = await ApiService.createExportTicket(eventId, { filters: { inviteLinkId: linkId || ANY_INVITE } }, 'xlsx');
  openExport(url);
}

/** Excel download of every registration that used one access code. */
export async function downloadAccessCodeRegistrations(eventId, code) {
  const { url } = await ApiService.createExportTicket(eventId, { filters: { inviteAccessCode: code } }, 'xlsx');
  openExport(url);
}
